import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const manualIntegralOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    columnBtn: false,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "业务编号",
            prop: "orderNumber",
            search: true,
            type: "input"
        },
        {
            label: "积分",
            prop: "integralValue",
            type: "input"
        },
        {
            label: "交易类型",
            search: true,
            prop: "detailType",
            type: "select",
            dicData: DIC.DETAIL_TYPE,

        },
        {
            label: "状态",
            prop: "status",
            search: true,
            type: "select",
            dicData: DIC.DETAIL_STATUS_TYPE,

        },
        {
            label: "备注",
            prop: "remarks",
            type: "input",
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return row.createTime = row.createTime * 1
            }
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input"
        },
        {
            label: "创建时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                console.log(row)
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};